export default "__VITE_ASSET__CcWP$UBK__"